import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, StatusBadge, Modal, formatBRL, formatDate } from '../../components/shared';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import toast from 'react-hot-toast';

const STATUS_FLOW = {
  pendente: ['aceito', 'cancelado'],
  aceito: ['em_rota', 'retirado', 'cancelado'],
  em_rota: ['entregue', 'cancelado'],
  entregue: [], retirado: [], cancelado: [],
};

const STATUS_OPCOES = ['pendente','aceito','em_rota','entregue','retirado','cancelado'];
const LABEL_STATUS  = { pendente:'Pendente', aceito:'Aceito', em_rota:'Em Rota', entregue:'Entregue', retirado:'Retirado', cancelado:'Cancelado' };
const LABEL_TIPO    = { entrega:'Entrega', retirada:'Retirada', mesa:'Mesa' };
const LABEL_PAG     = { dinheiro:'Dinheiro', cartao:'Cartão', cartao_credito:'Cartão Crédito', cartao_debito:'Cartão Débito', pix:'PIX', vale_refeicao:'Vale Refeição', vale_alimentacao:'Vale Alimentação', online:'Online' };

export default function AdminDashboard() {
  const { usuario } = useAuth();
  const [copiado, setCopiado]   = useState(false);
  const linkCardapio = usuario?.slug ? `${window.location.origin}/${usuario.slug}` : `${window.location.origin}/${usuario?.empresa_id}`;
  const copiarLink = () => { navigator.clipboard.writeText(linkCardapio); setCopiado(true); toast.success("Link copiado!"); setTimeout(() => setCopiado(false), 2000); };
  const [data, setData]         = useState(null);
  const [pedidos, setPedidos]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [tabStatus, setTab]     = useState('pendente');

  const [detalhe, setDetalhe]           = useState(null);
  const [carregandoDet, setCarregandoDet] = useState(false);
  const [novoStatus, setNovoStatus]     = useState('');
  const [obsStatus, setObsStatus]       = useState('');
  const [salvandoStatus, setSalvandoStatus] = useState(false);
  const [fuso, setFuso] = useState('America/Sao_Paulo');

  useEffect(() => {
    api.get('/configuracoes').then(r => { if (r.data.fuso_horario) setFuso(r.data.fuso_horario); }).catch(() => {});
  }, []);

  const carregar = async () => {
    try {
      const [dash, peds] = await Promise.all([
        api.get('/dashboard'),
        api.get('/pedidos', { params: { limit: 50, status: tabStatus || undefined } }),
      ]);
      setData(dash.data);
      setPedidos(peds.data.dados);
    } catch { toast.error('Erro ao carregar'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, [tabStatus]);

  const verDetalhe = async (id) => {
    setDetalhe({ _loading: true });
    setCarregandoDet(true);
    try {
      const { data } = await api.get(`/pedidos/${id}`);
      setDetalhe(data);
      setNovoStatus(data.status);
      setObsStatus('');
    } catch {
      toast.error('Erro ao carregar detalhes');
      setDetalhe(null);
    } finally { setCarregandoDet(false); }
  };

  const fecharDetalhe = () => { setDetalhe(null); setNovoStatus(''); setObsStatus(''); };

  const atualizarStatusModal = async () => {
    if (novoStatus === detalhe.status) return toast('Status não foi alterado', { icon: 'ℹ️' });
    setSalvandoStatus(true);
    try {
      await api.patch(`/pedidos/${detalhe.id}/status`, { status: novoStatus, observacao: obsStatus });
      toast.success('Status atualizado!');
      carregar();
      const { data } = await api.get(`/pedidos/${detalhe.id}`);
      setDetalhe(data);
      setNovoStatus(data.status);
      setObsStatus('');
    } catch { toast.error('Erro ao atualizar status'); }
    finally { setSalvandoStatus(false); }
  };

  const atualizarStatusRapido = async (id, status) => {
    try {
      await api.patch(`/pedidos/${id}/status`, { status });
      toast.success('Status atualizado!'); carregar();
    } catch { toast.error('Erro ao atualizar status'); }
  };

  const tabs = ['pendente','aceito','em_rota','entregue','retirado','cancelado'];
  const countStatus = (s) => data?.por_status?.find(p => p.status === s)?.count || 0;

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="admin_empresa" />
      <div className="main-content">
        <div className="topbar">
          <h1>Dashboard</h1>
          <button className="btn btn-secondary" onClick={carregar}><Icon name="refresh" size={16} /> Atualizar</button>
        </div>
        <div className="page-content">
          {/* Banner link cardápio */}
          <div style={{
            background: 'linear-gradient(135deg, #1A1A2E 0%, #2a2a45 100%)',
            borderRadius: 'var(--radius-lg)', padding: '16px 20px', marginBottom: 20,
            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
          }}>
            <div style={{ fontSize: '1.5rem' }}>🍽</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: '.9rem', marginBottom: 2 }}>
                Link público do seu cardápio
              </div>
              <div style={{ color: 'rgba(255,255,255,.5)', fontSize: '.78rem',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {linkCardapio}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={copiarLink} style={{
                background: copiado ? 'var(--success)' : 'rgba(255,255,255,.15)',
                color: '#fff', border: 'none', borderRadius: 8,
                padding: '8px 14px', cursor: 'pointer', fontSize: '.8rem',
                fontWeight: 600, fontFamily: 'inherit', transition: 'background .2s',
              }}>
                {copiado ? '✓ Copiado!' : '📋 Copiar link'}
              </button>
              <a href={linkCardapio} target="_blank" rel="noopener noreferrer" style={{
                background: 'var(--primary)', color: '#fff', border: 'none',
                borderRadius: 8, padding: '8px 14px', fontSize: '.8rem',
                fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4,
              }}>
                👁 Ver cardápio
              </a>
            </div>
          </div>
          {loading ? <div className="loading-center"><div className="spinner" /></div> : (
            <>
              <div className="stats-grid">
                <div className="stat-card orange">
                  <div className="icon"><Icon name="orders" size={20} /></div>
                  <div className="label">Pedidos Hoje</div>
                  <div className="value">{data?.pedidos_hoje || 0}</div>
                </div>
                {[
                  { s: 'pendente', label: 'Pendentes', color: 'yellow' },
                  { s: 'aceito',   label: 'Aceitos',   color: 'blue' },
                  { s: 'em_rota',  label: 'Em Rota',   color: 'orange' },
                  { s: 'entregue', label: 'Entregues', color: 'green' },
                ].map(({ s, label, color }) => (
                  <div key={s} className={`stat-card ${color}`} style={{ cursor: 'pointer' }}
                    onClick={() => setTab(s)}>
                    <div className="label">{label}</div>
                    <div className="value">{countStatus(s)}</div>
                  </div>
                ))}
              </div>

              {/* Faturamento 7 dias */}
              {data?.faturamento_7d?.length > 0 && (
                <div className="table-card" style={{ marginBottom: '20px' }}>
                  <div className="table-header"><h3>Faturamento — últimos 7 dias</h3></div>
                  <div className="table-wrapper">
                    <table>
                      <thead><tr><th>Data</th><th>Pedidos</th><th>Faturamento</th></tr></thead>
                      <tbody>
                        {data.faturamento_7d.map((d, i) => (
                          <tr key={i}>
                            <td>{new Date(d.dia + 'T12:00:00Z').toLocaleDateString('pt-BR', { timeZone: fuso })}</td>
                            <td>{d.pedidos}</td>
                            <td style={{ color: 'var(--success)', fontWeight: 700 }}>{formatBRL(d.total)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Pedidos por status */}
              <div className="table-card">
                <div className="table-header">
                  <h3>Pedidos</h3>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    <button className={`btn btn-sm ${tabStatus === '' ? 'btn-primary' : 'btn-secondary'}`}
                      onClick={() => setTab('')}>Todos</button>
                    {tabs.map(s => (
                      <button key={s} className={`btn btn-sm ${tabStatus === s ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={() => setTab(s)}>
                        {s.replace('_', ' ')} {countStatus(s) > 0 && `(${countStatus(s)})`}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr><th>#</th><th>Cliente</th><th>Tipo</th><th>Pagamento</th><th>Total</th><th>Status</th><th>Data</th><th>Ações</th></tr>
                    </thead>
                    <tbody>
                      {pedidos.map(p => (
                        <tr key={p.id}>
                          <td style={{ fontFamily: 'monospace', fontSize: '.75rem' }}>{p.id.slice(0, 8)}...</td>
                          <td>
                            <div style={{ fontWeight: 600 }}>{p.nome_cliente || '—'}</div>
                            <div style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>{p.telefone}</div>
                          </td>
                          <td><span className="badge badge-secondary">{p.tipo}</span></td>
                          <td style={{ fontSize: '.8rem' }}>{p.forma_pagamento?.replace('_', ' ')}</td>
                          <td style={{ fontWeight: 700, color: 'var(--primary)' }}>{formatBRL(p.valor_total)}</td>
                          <td><StatusBadge status={p.status} /></td>
                          <td style={{ fontSize: '.8rem' }}>{formatDate(p.data_hora, fuso)}</td>
                          <td>
                            <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                              <button className="btn btn-sm btn-primary" onClick={() => verDetalhe(p.id)}
                                style={{ fontSize: '.7rem' }}>Ver</button>
                              {(STATUS_FLOW[p.status] || []).map(s => (
                                <button key={s} className="btn btn-sm btn-secondary"
                                  onClick={() => atualizarStatusRapido(p.id, s)}
                                  style={{ fontSize: '.7rem' }}>
                                  → {s.replace('_', ' ')}
                                </button>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                      {!pedidos.length && (
                        <tr><td colSpan={8}>
                          <div className="empty-state"><Icon name="orders" /><h3>Nenhum pedido encontrado</h3></div>
                        </td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Modal detalhes do pedido */}
      <Modal open={!!detalhe} onClose={fecharDetalhe} title="Detalhes do Pedido" size="modal-lg">
        {carregandoDet || detalhe?._loading ? (
          <div className="loading-center" style={{ padding: '40px' }}><div className="spinner" /></div>
        ) : detalhe && (
          <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
              <div>
                <div style={{ fontSize: '.75rem', color: 'var(--text-muted)', marginBottom: '2px' }}>
                  Pedido #{detalhe.id?.slice(0, 8).toUpperCase()}
                </div>
                <div style={{ fontSize: '.85rem', color: 'var(--text-muted)' }}>{formatDate(detalhe.data_hora, fuso)}</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span className="badge badge-secondary">{LABEL_TIPO[detalhe.tipo] || detalhe.tipo}</span>
                <StatusBadge status={detalhe.status} />
              </div>
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: 0 }} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: '.875rem' }}>Cliente</div>
                <InfoLinha label="Nome"     value={detalhe.nome_cliente} />
                <InfoLinha label="Telefone" value={detalhe.telefone} />
                <InfoLinha label="E-mail"   value={detalhe.email} />
                <InfoLinha label="CPF"      value={detalhe.cpf_cliente} />
              </div>
              {detalhe.tipo === 'entrega' && (
                <div>
                  <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: '.875rem' }}>Endereço de Entrega</div>
                  <InfoLinha label="Logradouro"  value={detalhe.endereco} />
                  <InfoLinha label="Número"      value={detalhe.numero} />
                  <InfoLinha label="Bairro"      value={detalhe.bairro} />
                  <InfoLinha label="Complemento" value={detalhe.complemento} />
                  <InfoLinha label="Cidade/UF"   value={detalhe.cidade && detalhe.estado ? `${detalhe.cidade} / ${detalhe.estado}` : null} />
                  <InfoLinha label="CEP"         value={detalhe.cep} />
                </div>
              )}
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: 0 }} />

            <div>
              <div style={{ fontWeight: 700, marginBottom: '10px', fontSize: '.875rem' }}>Itens do Pedido</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '.85rem' }}>
                <thead>
                  <tr style={{ background: 'var(--secondary)', textAlign: 'left' }}>
                    <th style={{ padding: '8px 10px' }}>Produto</th>
                    <th style={{ padding: '8px 10px', textAlign: 'center' }}>Qtd</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right' }}>Unit.</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right' }}>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {(detalhe.itens || []).map((it, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '8px 10px' }}>
                        <div style={{ fontWeight: 600 }}>{it.descricao_produto}</div>
                        {it.observacao && <div style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>{it.observacao}</div>}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'center' }}>{it.quantidade}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right' }}>{formatBRL(it.valor_unitario)}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 700 }}>{formatBRL(it.valor_total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', padding: '10px 10px 0' }}>
                <span style={{ fontSize: '.85rem', color: 'var(--text-muted)' }}>
                  Pagamento: <strong>{LABEL_PAG[detalhe.forma_pagamento] || detalhe.forma_pagamento}</strong>
                </span>
                <span style={{ fontWeight: 800, fontSize: '1.1rem', color: 'var(--primary)' }}>
                  Total: {formatBRL(detalhe.valor_total)}
                </span>
              </div>
              {detalhe.observacao && (
                <div style={{ marginTop: '10px', padding: '10px', background: 'var(--secondary)', borderRadius: 'var(--radius)', fontSize: '.85rem' }}>
                  <strong>Obs:</strong> {detalhe.observacao}
                </div>
              )}
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: 0 }} />

            <div>
              <div style={{ fontWeight: 700, marginBottom: '10px', fontSize: '.875rem' }}>Atualizar Status</div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                <div style={{ flex: '1 1 160px' }}>
                  <label className="form-label" style={{ fontSize: '.8rem' }}>Novo status</label>
                  <select className="form-control" value={novoStatus} onChange={e => setNovoStatus(e.target.value)}>
                    {STATUS_OPCOES.map(s => <option key={s} value={s}>{LABEL_STATUS[s]}</option>)}
                  </select>
                </div>
                <div style={{ flex: '2 1 200px' }}>
                  <label className="form-label" style={{ fontSize: '.8rem' }}>Observação (opcional)</label>
                  <input className="form-control" value={obsStatus} onChange={e => setObsStatus(e.target.value)} placeholder="Ex: saiu para entrega" />
                </div>
                <button className="btn btn-primary" onClick={atualizarStatusModal}
                  disabled={salvandoStatus || novoStatus === detalhe.status}>
                  {salvandoStatus ? 'Salvando...' : 'Atualizar'}
                </button>
              </div>
            </div>

            {detalhe.historico?.length > 0 && (
              <>
                <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, marginBottom: '10px', fontSize: '.875rem' }}>Histórico de Status</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {detalhe.historico.map((h, i) => (
                      <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', fontSize: '.8rem' }}>
                        <div style={{ width: '130px', color: 'var(--text-muted)', flexShrink: 0 }}>{formatDate(h.data_hora, fuso)}</div>
                        <div>
                          {h.status_anterior
                            ? <><StatusBadge status={h.status_anterior} /> → <StatusBadge status={h.status_novo} /></>
                            : <StatusBadge status={h.status_novo} />
                          }
                          {h.usuario_nome && <span style={{ color: 'var(--text-muted)', marginLeft: '6px' }}>por {h.usuario_nome}</span>}
                          {h.observacao && <div style={{ color: 'var(--text-muted)', marginTop: '2px' }}>{h.observacao}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

          </div>
        )}
      </Modal>
    </div>
  );
}

function InfoLinha({ label, value }) {
  if (!value) return null;
  return (
    <div style={{ fontSize: '.82rem', marginBottom: '4px', display: 'flex', gap: '6px' }}>
      <span style={{ color: 'var(--text-muted)', minWidth: '80px' }}>{label}:</span>
      <span style={{ fontWeight: 500 }}>{value}</span>
    </div>
  );
}
